<template lang="pug">
  //- .base-status — простой класс-зацепка для ::v-deep из родителя:
  //- к БЭМ-имени .status снаружи обращаться не нужно
  .b-status.base-status(v-if="!editable" :class="{ gray }" :style="badgeStyle" :title="selectedLabel") {{ selectedLabel }}
  BaseTileDropdown(v-else :opened="dropdownOpened" @close="dropdownOpened = false")
    template(#selected)
      .b-status.base-status.-clickable(
        :class="{ gray }"
        :style="badgeStyle"
        :title="selectedLabel"
        @click="dropdownOpened = !dropdownOpened"
        ) {{ selectedLabel }}
    template(#default)
      .b-status.base-status.-clickable(
        v-for="item in itemsInDropdown"
        :key="item.value"
        :style="{ backgroundColor: item.color }"
        :title="item.label"
        @click="select(item)"
        ) {{ item.label }}
</template>

<script>
import BaseTileDropdown from '@/components/BaseTileDropdown.vue';

// когда у элемента нет своего цвета
const DEFAULT_COLOR = '#99A3C5';

/**
 * Плашка статуса с выбором из списка.
 *
 * Своего списка статусов не знает: что показывать, решает вызывающий и
 * передаёт в items. Элемент — это { value | id, label | name, color },
 * поэтому сущности вроде этапов воронки подходят как есть.
 */
export default {
  name: 'BaseStatus',
  components: { BaseTileDropdown },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    // значение активного элемента
    value: [String, Number],
    editable: Boolean,
    gray: Boolean,
    emptyLabel: {
      type: String,
      default: 'Не выбрано',
    },
  },
  data() {
    return {
      dropdownOpened: false,
    };
  },
  computed: {
    options() {
      return this.items.map(item => ({
        value: item.value ?? item.id,
        label: item.label ?? item.name ?? '',
        color: item.color || DEFAULT_COLOR,
      }));
    },
    selected() {
      return this.options.find(item => item.value === this.value) ?? null;
    },
    selectedLabel() { return this.selected?.label ?? this.emptyLabel; },
    badgeStyle() {
      return { backgroundColor: this.selected?.color ?? DEFAULT_COLOR };
    },
    itemsInDropdown() {
      return this.options.filter(item => item.value !== this.value);
    },
  },
  methods: {
    select(item) {
      this.dropdownOpened = false;
      if (item.value === this.value) return;

      this.$emit('change', item.value);
    },
  },
};
</script>

<style scoped lang="scss">
.status {
  display: inline-block;
  text-align: center;
  color: var(--color-white);
  font-weight: 700;
  font-size: 12px;
  line-height: 1.15;
  min-width: 140px;
  padding: 4px 8px;
  border-radius: 4px;
  box-sizing: border-box;

  &--clickable {
    cursor: pointer;
  }

  &.gray {
    filter: grayscale(1);
    opacity: .6;
  }
}
</style>
